import { SWReactCountryIcons } from "@similarweb/icons";
import { getCountryIdOrFallback } from "app/pages/sales-intelligence/sub-modules/signals/utils/countries";
import type { PropsWithChildren } from "react";
import { StyledFilterButtonLabel } from "./styles";

type Props = PropsWithChildren<{
    showIcon: boolean;
    countryCode: number;
}>;

const FilterButtonLabelWithCountryIcon = ({ showIcon, countryCode, children }: Props) => {
    return (
        <StyledFilterButtonLabel>
            {showIcon ? <SWReactCountryIcons
                    size="xs"
                    countryCode={getCountryIdOrFallback(countryCode)}
                /> : null}
            {children}
        </StyledFilterButtonLabel>
    );
};

export default FilterButtonLabelWithCountryIcon;
